export default function MapUrbanisme({ imageUrl }) {
  if (!imageUrl) {
    return (
      <div className="h-[350px] rounded-lg bg-slate-100 animate-pulse flex items-center justify-center">
        <span className="text-sm text-slate-400">Carte PLU en cours de génération...</span>
      </div>
    )
  }

  return (
    <img
      src={imageUrl}
      alt="Plan Local d'Urbanisme"
      className="w-full rounded-lg"
      loading="lazy"
    />
  )
}
